import { AuthenticationService } from '../../../../../framework/authentication/services/authentication.service'
import { Injectable } from '@angular/core'
import { combineLatest, of, Subscription } from 'rxjs'
import { ConfigurationRouteService } from './configurationRoute.service'
import { mergeMap, take } from 'rxjs/operators'
import { DataLayerService } from '../../../../../framework/analytics/datalayer.service'
import { DealQueryService } from '../../../services/dealQuery.service'
import { DealOption } from 'modules/deals/utilities/deal-types'
import { getDealOptionKey, getDealOptionValue } from 'modules/deals/utilities/deal-helpers'

export interface ConfigurationAnalyticsEvent {
    name: string
    id?: string
    options?: DealOption[]
    pricing?: {
        id?: string
        pricePerMonthIncVAT?: number
        pricePerMonthExVAT?: number
        incVAT?: boolean
        fiscalValue?: number
    }
    dealId: string
}

@Injectable()
export class ConfigurationAnalyticsService {
    constructor(
        private authenticationService: AuthenticationService,
        private dealQueryService: DealQueryService,
        private configurationRouteService: ConfigurationRouteService,
        private dataLayerService: DataLayerService
    ) {}

    push(data: ConfigurationAnalyticsEvent): Subscription {
        const configuration$ = this.dealQueryService.fetchDealConfiguration(data.dealId)

        const configurationId$ = of(data.dealId)

        const route$ = configurationId$.pipe(
            mergeMap(configurationId => this.configurationRouteService.getActiveConfigurationRoute(configurationId))
        )

        return combineLatest([configuration$, route$, this.authenticationService.currentUser])
            .pipe(take(1))
            .subscribe(([configuration, route, user]) => {
                // get shareable list of options, exclude options with personal data
                const options = configuration.options
                    .map(
                        option =>
                            `${getDealOptionKey(option).toLowerCase()}=${getDealOptionValue(option)
                                .toString()
                                .toLowerCase()}`
                    )
                    .join('|')

                // notify datalayer of step change
                this.dataLayerService.push({
                    event: data.name,
                    carBrand: 'tesla',
                    carModel: `${configuration.modelName}`,
                    stepNr: route ? (route.index + 1).toString() : undefined,
                    stepName: route ? route.category || route.id : undefined,
                    Options: options,
                    userId: !user ? undefined : user.id,
                    orderId: data.dealId,
                    Value: configuration.pricing.pricePerMonthExVAT.toString(),
                    Status: undefined,
                })
            })
    }
}
